import styled from 'styled-components';

export const FlightPredictionTagWrapper = styled.div`
  pointer-events: all;
`;

export const TooltipWrapper = styled.div``;

export const TooltipTitle = styled.div``;

export const TooltipStage = styled.div``;
